export default __webpack_public_path__ + "static/media/education2.9f074bd2.jpg";